<template>
    <div>
        <!-- Language settings menu for medium and wide screen -->
        <v-menu
            v-model="menu"
            offset-y
            top
            rounded
            attach="#activator"
            :min-width="menuWidth"
            transition="slide-y-reverse-transition"
        >
            <LanguageSettingsItems :language="language"/>
        </v-menu>

        <!-- Language settings dialog for mobile -->
        <div
            v-if="$vuetify.breakpoint.smAndDown"
        >
            <v-dialog
                v-model="dialog"
                :width="dialogWidth"
                overlay-opacity="0.15"
            >
                <v-card outlined>
                    <LanguageSettingsItems :language="language"/>
                </v-card>
            </v-dialog>
        </div>
        <!-- /Language settings dialog for mobile -->

        <v-btn
            class="text-capitalize"
            small
            fab
            id="activator"
            @click.prevent="!$vuetify.breakpoint.smAndDown ? menu = !menu : dialog = !dialog"
        >
            {{ language }}
        </v-btn>
    </div>
</template>

<script>
    import LanguageSettingsItems from "@/components/threeDController/components/LanguageSettingsItems";

    export default {
        name: 'LanguageSettings',
        components: {
            LanguageSettingsItems
        },
        props: {
            language: {
                type: String,
                required: true,
            },
        },
        data() {
            return {
                menu: false,
                dialog: false,
                menuWidth: 150,
                dialogWidth: 150
            }
        }
    };
</script>


// WEBPACK FOOTER //
// src/components/threeDController/components/LanguageSettings.vue